import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectGlobalState } from 'src/app/app.selectors';
import { AppState } from 'src/app/app.state';
import { dayjs } from 'src/app/dayjs.lib';
import { BookingsState } from './bookings.state';

export const selectBookingsState = createFeatureSelector<BookingsState>('bookings');

export const selectBookingTickets = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.bookings?.[0]?.tickets ?? [];
});

export const selectHasCurrentBookings = createSelector(selectBookingsState, (state: BookingsState) => {
	const afterBooking =
		state?.bookings?.[0]?.tickets?.filter((t) => dayjs(t.latest_booking_date).isAfter(dayjs().startOf('day')))
			.length > 0;
	const sameDayAsBooking =
		state?.bookings?.[0]?.tickets?.filter((t) => dayjs(t.latest_booking_date).isSame(dayjs().startOf('day')))
			.length > 0;

	return afterBooking || sameDayAsBooking;
});

export const selectBookingTicketsByPackageId = (packageId: string) =>
	createSelector(selectBookingsState, (state: BookingsState) => {
		return state?.bookings?.[0].tickets.filter((t) => t.package_id === packageId);
	});

export const selectOpenEntitlement = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.openEntitlement ?? null;
});

export const selectNewBookingDate = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.openEntitlement.newBookingDate ?? null;
});

export const selectNewBookingTime = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.openEntitlement.newBookingTime ?? null;
});

export const selectEventDates = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.events?.[0]?.dates ?? [];
});

export const selectAllTicketsForEntitlement = (entitlementId: string) =>
	createSelector(selectBookingsState, (state: BookingsState) => {
		return state?.bookings?.[0].tickets.filter((t) =>
			t.entitlements.find((e) => e.entitlement_id === entitlementId)
		);
	});

export const selectAllTicketsForCurrentEntitlement = createSelector(selectBookingsState, (state: BookingsState) => {
	return state?.bookings?.[0].tickets.filter((t) => {
		if (t.package_id === state.openEntitlement.ticket.package_id) {
			return t.entitlements.find((e) => e.entitlement_id === state?.openEntitlement.entitlement.entitlement_id);
		}
	});
});

export const selectModifySpinner = createSelector(selectGlobalState, (state: AppState) => {
	return state.spinner.showModifyCalendarSpinner;
});

export const selectSwFailedCount = createSelector(selectBookingsState, (state: BookingsState) => {
	return state.swFailedCount || null;
});
